<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-xs-12"></div>
      <div class="col-xs-12 col-lg-6">
        <div class="card card-body">
          <h1 class="color-primary">Poderia informar seu salário atual?</h1>
          <div>
            <label class="mt-3">Salário mensal</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">R$</span>
              </div>
              <currency-input
                v-model="apply.remuneration"
                class="form-control"
                placeholder="0,00"
              />
            </div>
          </div>
          <button
            :disabled="load"
            @click="saveRemuneration"
            type="button"
            class="btn btn-success"
          >
            <div v-show="load" class="spinner-border text-light" role="status">
              <span class="sr-only"></span>
            </div>
            {{ !load ? "Salvar" : "" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    apply: {
      remuneration: 0,
    },
    load: false,
  }),
  mounted() {
    axios.get("/candidates/apply/remuneration/").then((response) => {
      if (response.data.status) {
        this.goToVideo();
      }
    });
  },
  methods: {
    goToVideo() {
      eventBus.$emit("videoScreen", { status: true });
    },
    saveRemuneration() {
      if (this.apply.remuneration == 0) {
        this.$toast.error("Salário não pode ser zero");
        return;
      }
      this.load = true;
      axios
        .put("/candidates/apply/remuneration/", {
          apply: this.apply,
        })
        .then((response) => {
          this.goToVideo();
          this.load = false;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(
            "Erro ao salvar pretenção salarial, confira o valor e tente novamente"
          );
          this.load = false;
        });
    },
  },
};
</script>

<style>
</style>